import React from 'react';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputTextField from '../../Fields/InputTextField';
import InputRadioGroupField from '../../Fields/InputRadioGroupField';
import InputSelectField from '../../Fields/InputSelectField';


class BillingProfileGeneralPanel extends React.Component {
  _onInputChange(inputId) {
    return value => {
      switch (inputId) {
        case 'active':
        case 'validation_only':
          value = value === 'true';
          break;
        default:
      }

      this.props.onBillingProfileInputChange(inputId, value);
    };
  }


  render() {
    const {
      billingProfile,
      fieldConfiguration,
      staticFacility,
      newMode,
      editMode
    } = this.props;

    return (
      <div>
        <FieldGroup>
          <Field label="Name"
            id="parkchirp--billing-profile--name"
            layout="columns">
            <InputTextField inputId="parkchirp--billing-profile--name"
              value={billingProfile.fields.name.value}
              disabledMode={billingProfile.fields.validation_only.value}
              editMode={(newMode || editMode)}
              onChange={this._onInputChange('name')}
            />
          </Field>
          <Field label="Status"
            id="parkchirp--billing-profile--active"
            layout="columns">
            <InputRadioGroupField inputId="parkchirp--billing-profile--status"
              options={fieldConfiguration.active.options}
              value={billingProfile.fields.active.value}
              editMode={(newMode || editMode)}
              onChange={this._onInputChange('active')}
            />
          </Field>
          <Field label="Validation Only"
            id="parkchirp--billing-profile--validation-only"
            layout="columns">
            <InputRadioGroupField inputId="parkchirp--billing-profile--validation-only"
              options={fieldConfiguration.validation_only.options}
              value={billingProfile.fields.validation_only.value}
              editMode={newMode}
              onChange={this._onInputChange('validation_only')}
            />
          </Field>
        </FieldGroup>
        <FieldGroup>
          <Field label="Facility"
            id="parkchirp--billing-profile--facility-id"
            layout="columns">
            <InputSelectField inputId="parkchirp--billing-profile--facility-id"
              options={[{ value: null, label: '' }, ...fieldConfiguration.facility.options]}
              value={billingProfile.fields.facility_id.value}
              editMode={((newMode || editMode) && !staticFacility)}
              onChange={this._onInputChange('facility_id')}
            />
          </Field>
        </FieldGroup>
        <FieldGroup>
          <Field label="Parking Period"
            id="parkchirp--billing-profile--parking-period"
            layout="columns">
            <InputSelectField inputId="parkchirp--billing-profile--parking-period"
              options={[{ value: null, label: '' }, ...fieldConfiguration.parking_period.options]}
              value={billingProfile.fields.parking_period.value}
              editMode={(newMode || editMode)}
              onChange={this._onInputChange('parking_period')}
            />
          </Field>
        </FieldGroup>
      </div>
    );
  }
}
export default BillingProfileGeneralPanel;
